@let loadingConfig = loadingState().loadingConfig;
<div class="container-div" [ngClass]="loadingConfig.type">
  <div class="card-div">
    <div class="animation">
      <div class="spinner-border m-5" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
    <div class="text">
      <h1 #title class="title">{{ actualContent().title }}</h1>
      @if (actualContent().subtitle) {
        <h1 class="subtitle">{{ actualContent().subtitle }}</h1>
      }
    </div>
  </div>
</div>
